import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { Listing, BPLMasterDataAddEdit } from './Pages';

export const BPLMasterDataSync = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={Listing} />
        <Route exact path = {`${match.path}/addEdit`} component={BPLMasterDataAddEdit} />
    </Fragment>
)